<template>
  <div class="check-flow-modal">
    <Modal
      v-model="modal"
      title="结算核对"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div class="modal-main">
        <p style="margin-bottom: 8px">
          ①运营提交确认即表示对本次账单结算金额确认无误，请根据实际情况进行审批操作。
        </p>
        <p style="margin-bottom: 8px">
          ②确定后，机构端将可见账单的结算金额，且账单中对应的课时、节次将<strong>不再支持退款、调整上课时间等。</strong>
        </p>

        <p style="font-size: 18px">
          结算金额(元)：<span
            class="color-red"
            style="margin-right: 20px; font-size: 18px"
          >¥{{ totalFee }}</span>
          机构应结算金额(元)：<span
            class="color-red"
            style="font-size: 18px"
          >¥{{ orgFee }}</span>
        </p>
      </div>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="failShow"
      title="提示"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div class="modal-main">
        <p class="flex align-items" style="margin-bottom: 8px">
          <Icon
            type="ios-alert"
            color="#f9a315"
            style="margin-right: 8px"
            size="18"
          ></Icon><span>月份账单中存在审批中的退款单，请处理后再次确认账单!</span>
        </p>
        <Table
          :loading="tableLading"
          :columns="tableColumns"
          :data="refundOrderlist"
          :max-height="450"
          border
        ></Table>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleClose">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import orderCenterApi from '@/request/orderCenter/index.js';
import BigNumber from 'bignumber.js';
import { mapState } from 'vuex';
export default {
  components: {

  },
  props: {
    // totalFee: {
    //   type: String,
    //   default: ''
    // },
    // orgFee: {
    //   type: String,
    //   default: ''
    // }
  },

  data() {
    return {
      modal: false,
      failShow: false,
      modalLoading: false,
      totalFee: '',
      orgFee: '',
      statementId: '',
      orgId: '',
      tableColumns: [{
        title: '退款单号',
        key: 'insOrderId',
        width: 180
      }, {
        title: '学校',
        key: 'schoolName'
      }, {
        title: '学生姓名',
        key: 'studentName',
        width: 120
      }, {
        title: '年级班级',
        key: 'gradeClassName',
        width: 150
      }],
      tableLading: false,
      refundOrderlist: []
    };
  },
  //
  watch: {

  },
  computed: {
    ...mapState(['userInfo'])
    // totalFee() {
    //   return this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalFee'] : ''
    // },
    // orgFee() {
    //   return this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['orgFee'] : ''
    // }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleShow(row) {
      if (row) {
        this.totalFee = row.settleAvailAmt;
        this.statementId = row.statementId;
        this.orgId = row.orgId;
        this.orgFee = row.merchantAmt;
      }
      this.modal = true;
    },
    // 运营提交
    handleAdminCfm() {
      const settleAvailAmt = this.totalFee ? new BigNumber(this.totalFee.replace(/,/g, '')) : 0;

      this.$Spin.show();
      orderCenterApi.uploadStatementStsByAdmin({ statementId: this.statementId, orgId: this.orgId, settleAvailAmt: settleAvailAmt ? settleAvailAmt.times(100) * 1 : 0 }).then(res => {
        this.$Spin.hide();
        if (res.data.status == 200) {
          this.$Message.success('提交成功');
          this.modal = false;
          this.$emit('on-uploadStaSts');
        } else if (res.data.status == 4802 || res.data.status == 13304) {
          setTimeout(() => {
            this.$Modal.warning({
              title: '温馨提示',
              content: '账单数据已更变，请重新加载后再次确认!',
              onOk: () => {
                location.reload();
              }
            });
          }, 500);
        } else if (res.data.status == 3617) {
          this.modal = false;
          this.refundOrderListBySettlementId();
        }
      });
    },
    async refundOrderListBySettlementId() {
      this.refundOrderlist = [];
      this.tableLading = true;
      this.failShow = true;
      const res = await orderCenterApi.refundOrderListBySettlementId({
        settlementId: this.statementId
      });

      this.tableLading = false;
      if (res.status == 200) {
        this.refundOrderlist = res.message;
      }
    },
    handleCancel() {
      this.modal = false;
      this.$emit('on-cancel', {

      });
    },
    handleOk() {
      this.handleAdminCfm();
    },
    handleClose() {
      this.failShow = false;
    }

  }
};
</script>

<style lang="scss" scoped>
.modal-main {
}
</style>
